import script from "./AppSectionHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSectionHeader.vue?vue&type=script&setup=true&lang=ts"

import "./AppSectionHeader.vue?vue&type=style&index=0&id=b2d81df6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2d81df6"]])

export default __exports__